import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=2a72e8e8&"
import script from "./Waves.vue?vue&type=script&lang=js&"
export * from "./Waves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "4d21b390"
  
)

export default component.exports